import React, { useState } from "react";
import Button from "./Button";
import noImage from "../data/images/no-image1.jpeg";
import { useStateContext } from "../contexts/ContextProvider";
import EditRoomForm from "./EditRoomForm";
import EditPhotosForm from "./EditPhotosForm";

const initialErrorState = {
  roomName: "",
  rent: "",
  shortDesc: "",
  longDesc: "",
};

const EditRoom = (props) => {
  const { currentRoomId, handleRoomUpdate, propertyId } = props;
  const { rooms, modal, handleModal } = useStateContext();
  const [room, setRoom] = useState(rooms.find((x) => x.id === currentRoomId));
  const [roomError, setRoomError] = useState(initialErrorState);
  const [duplicateNameError, setDuplicateNameError] = useState(false);

  let currentPropertyRooms = rooms.filter((x) => x.propertyId === propertyId);
  const otherRooms = currentPropertyRooms.toSpliced(
    currentPropertyRooms.findIndex((x) => x.id === currentRoomId),
    1
  );

  const handleChange = (event) => {
    const { name, value } = event.target;

    const reg = new RegExp("^[0-9]*$"); // is integers or empty?
    let safeValue;

    if (name === "rent" || name === "securityDep") {
      if (reg.test(value)) {
        safeValue = value;
      } else {
        return;
      }
    }

    //Check for repeat room names
    if (
      name === "roomName" &&
      otherRooms.find((item) => item.roomName === value.toLowerCase())
    ) {
      setDuplicateNameError(true);
    } else {
      setDuplicateNameError(false);
    }

    safeValue = value;
    setRoom((prevState) => ({ ...prevState, [name]: safeValue }));
  };

  const handleCheckbox = (event) => {
    const { name, checked } = event.target;

    if (name === "maleOnly" && checked === true) {
      setRoom((prevState) => ({
        ...prevState,
        femaleOnly: false,
        isCoEd: false,
      }));
    }
    if (name === "femaleOnly" && checked === true) {
      setRoom((prevState) => ({
        ...prevState,
        maleOnly: false,
        isCoEd: false,
      }));
    }
    if (name === "isCoEd" && checked === true) {
      setRoom((prevState) => ({
        ...prevState,
        maleOnly: false,
        femaleOnly: false,
      }));
    }

    setRoom((prevState) => ({ ...prevState, [name]: checked }));
  };

  const hasRoomErrors = () => {
    if (room.roomName === "" || duplicateNameError) {
      activateError("roomName");
    } else if (room.rent === "") {
      activateError("rent");
    } else if (room.shortDesc === "") {
      activateError("shortDesc");
    } else if (room.longDesc === "") {
      activateError("longDesc");
    } else {
      return false;
    }
    return true;
  };

  const activateError = (item) => {
    setRoomError((prevState) => ({
      ...prevState,
      [item]: "animate-shake text-red-600 border-red-600",
    }));
    setTimeout(() => {
      setRoomError((prevState) => ({
        ...prevState,
        [item]: "",
      }));
    }, 500);
    clearTimeout();
  };

  const handleUpdate = () => {
    if (hasRoomErrors()) {
      return;
    } else {
      handleRoomUpdate(room);
      handleModal("editRoom");
    }
  };

  return (
    <div
      className="w-screen h-screen fixed top-0 left-0 right-0 bg-white my-20 z-10 
      overflow-y-scroll overflow-auto"
    >
      {modal.editPhotos && <EditPhotosForm room={room} setRoom={setRoom} />}
      <div className="relative grid justify-items-center pt-20">
        <img
          src={
            room.images[0] instanceof Blob
              ? URL.createObjectURL(room.images[0])
              : room.images[0] || noImage
            //remove this logic once image handling is setup
          }
          alt="Roomate's Avatar"
          className="flex justify-center h-28 w-28 object-cover rounded-full hover:border-snappily-orange border-2"
          onClick={() => handleModal("editPhotos")}
        />
        <div
          className="absolute bottom-10 text-blue-500 hover:text-blue-700 cursor-pointer 
        bg-white opacity-80 rounded-2xl p-1"
          onClick={() => handleModal("editPhotos")}
        >
          Edit Photos
        </div>
      </div>
      <EditRoomForm
        room={room}
        roomError={roomError}
        duplicateNameError={duplicateNameError}
        handleChange={handleChange}
        handleCheckbox={handleCheckbox}
      />
      <div
        className="flex justify-center fixed bottom-0 w-full bg-white
       border-gray-200 border-t-1 py-10"
      >
        <Button
          background="bg-slate-400"
          text="text-white"
          opacity="bg-opacity-100"
          title={"Cancel"}
          height="h-10"
          width="w-24"
          borderColor="border-none"
          borderHover="hover:border-snappily-orange"
          customFunc={() => handleModal("editRoom")}
        />
        <Button
          background="bg-snappily-orange"
          text="text-white"
          opacity="bg-opacity-100"
          title={"Update"}
          height="h-10"
          width="w-24"
          borderColor="border-none"
          borderHover="hover:border-snappily-orange"
          customFunc={handleUpdate}
        />
      </div>
    </div>
  );
};

export default EditRoom;
